












































import Vue from "vue";
import { AInput, Dropdown } from "@canvas/componentlibrary";
import { mapActions, mapState } from "vuex";
import { getErrorMsg } from "@/types";
import { Form, CustomRenderers } from "@canvas/vuejsonschemaform";

export default Vue.extend({
  components: {
    AInput,
    Form,
  },
  data(): { [key: string]: any } {
    return {
      projectDetailFormStructure: {},
      formInitialData: null,
      dropdownOpen: false,
      inActiveReason: null,
      saveBtn: {
        isDisabled: false,
        text: "Submit",
      },
      comments: "",
      inActiveReasonOptions: [],
      inActiveResponse: null,
      validateStatus: {
        reason: "",
        comments: "",
      },
    };
  },
  computed: {
    ...mapState("appModule", {
      partialProject: "partialProject",
      selectedEc: "selectedEc",
    }),
    hasFormStructure(): boolean {
      return Object.keys(this.projectDetailFormStructure).length > 0;
    },
    renderers() {
      (CustomRenderers["*"] as any) = {
        ...CustomRenderers["*"],
      };
      return CustomRenderers;
    },
  },
  methods: {
    ...mapActions("appModule", [
      "getInactivationReasons",
      "submitInActive",
      "createProject",
      "getFormStructureSchema",
    ]),
    updateReason(item: any) {
      this.inActiveReason = item;
      this.validateStatus.reason = "success";
    },
    validateAndSetError(formData: any, form: any, attribute: string) {
      if (formData.attribute_data[attribute].length === 0) {
        // @ts-ignore
        form.formdata.statuses.attribute_data[attribute] = "error";
      }
    },
    async goToNextStep() {
      try {
        let formdata_project: any = {};
        if (this.hasFormStructure) {
          const form = (this as any).$refs.form2 as Form;
          formdata_project = form.getFormData();
          this.validateAndSetError(
            formdata_project,
            form,
            "know_about_livspace"
          );
          this.validateAndSetError(
            formdata_project,
            form,
            "know_about_experience_center"
          );
        }
        this.clearValidationStatus();

        this.validateField("reason", !this.inActiveReason);
        this.validateField("comments", !this.comments);

        if (this.hasValidationError()) {
          return;
        }

        const projectDetails = await (this as any).createProject(
          Object.assign(formdata_project, {
            ec_id: (this as any).selectedEc.name,
          })
        );
        const inactivationReasonItem = this.getInactivationReasonItem(
          "topmost_inactivation_reason"
        );
        const inactivationComments = this.getInactivationReasonItem(
          "stage_change_reason"
        );

        const payloadData = {
          data: [
            {
              option_id: this.inActiveReason.id,
              descriptive_response: null,
              question_id: inactivationReasonItem.id,
            },
            {
              option_id: null,
              descriptive_response: this.comments,
              question_id: inactivationComments.id,
            },
          ],
          form_id: this.inActiveResponse.id,
        };

        await this.submitInActive(payloadData);
        (this as any).$store.dispatch("uiModule/addToast", {
          severity: "success",
          message: "Project updated to In-Active",
        });
        this.$router.push({
          path:
            "/lead/" +
            this.$router.currentRoute.params.lead_id +
            "/" +
            this.partialProject.project_id +
            "/assignment",
        });
      } catch (err) {
        (this as any).$store.dispatch("uiModule/addToast", {
          severity: "error",
          message: getErrorMsg(err),
        });
      }
    },
    validateField(field: string, condition: boolean) {
      if (condition) {
        this.validateStatus[field] = "error";
      }
    },
    getInactivationReasonItem(name: string) {
      return this.inActiveResponse.data.find((item: any) => item.name === name);
    },
    handleInput(event: any) {
      this.comments = event;
      this.validateStatus.comments = "success";
    },
    clearValidationStatus() {
      this.validateStatus = {
        reason: "",
        comments: "",
      };
    },
    hasValidationError() {
      return Object.values(this.validateStatus).some(
        (status) => status === "error"
      );
    },
  },
  async mounted() {
    const inActiveRes = await (this as any).getFormStructureSchema(
      "onHold_inActive_reasons"
    );
    this.projectDetailFormStructure = await (this as any).getFormStructureSchema(
      "onHold_inActive_project_details"
    );
    let inactivationReasonOptions: any = [];
    const inactivationReasonItem = inActiveRes.inactivation_reasons.data.find(
      (item: any) => item.name === "topmost_inactivation_reason"
    );
    if (inactivationReasonItem && inactivationReasonItem.options) {
      inactivationReasonOptions = inactivationReasonItem.options;
    }
    this.inActiveReasonOptions = inactivationReasonOptions;
    this.inActiveResponse = inActiveRes.inactivation_reasons;
  },
});
